import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEOrthoTargetType as OEOrthoTargetType_, OEOrthoStartSelectionContent} from './oe-ortho-consts';

export const OEOrthoTargetType = OEOrthoTargetType_;

export const OEOrthoTargets = new OEVersionTargets(
    {
        [OEOrthoTargetType.anatomy]: [
// @ADD_TARGET_ORTHO_OETARGET
            OETarget.humanArm,
            OETarget.humanShoulderGirdle,
            OETarget.humanUpperArmElbow,
            OETarget.humanForearm,
            OETarget.humanHand,
            OETarget.humanLeg,
            OETarget.humanHip2,
            OETarget.humanThighKnee,
            OETarget.humanLowerLeg,
            OETarget.humanAnkleFoot,
            OETarget.humanTrunk,
            OETarget.humanNeckBack,
            OETarget.humanChestWall,
            OETarget.humanAbdominalWall,
            OETarget.humanPelvis,
            OETarget.humanSpine
        ],
        [OEOrthoTargetType.head]: [
            OETarget.humanHead
        ]
    },
    {
        [OEOrthoTargetType.anatomy]: OETarget.humanArm,
        [OEOrthoTargetType.head]: OETarget.humanHead,
    },
    {
        [OEOrthoTargetType.anatomy]: OETarget.humanHip2
    }
);

export const OEOrthoFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            headModule: !isLicensing,
            anatomyTargetSelection: !isLicensing,
            headTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.headModule = true;
                featureAccess.anatomyTargetSelection = true;
                featureAccess.headTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEOrthoTargets);

export const OEOrthoStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEOrthoTargets,
    OEOrthoStartSelectionContent
);